import { DocumentData } from "firebase/firestore";
import { atom } from "recoil";

// 店舗ごとの減価率の行列
export const netSalesCostRatioStore = atom<DocumentData>({
  key: "net_sales_cost_ratio",
  default: [],
});
